<template>
<div class="news-main">
	<div class="about-top">
		<img src="../assets/abtus_banner.png" style="max-width:100%;" width="100%" />
	</div>
<el-container class="news-main-container">
    <el-aside width="200px" height="auto" style="">
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="vertical" @select="handleSelect">
        <li  class="" style="padding-left: 20px;height: 40px;background:#2fa5ff; color:#fff;    line-height: 40px; vertical-align: middle;line-height: 40px;">合作案例</li>
				<!-- 团膳企业& -->
					<el-menu-item class="new-menu" index="0">服务企业</el-menu-item>
					<el-menu-item class="new-menu" index="1">一卡通厂商</el-menu-item>
        </el-menu>
    </el-aside>
    <el-container class="news-content">
        <el-main>
            <div class="el-menu-select-box">
                <ul>
                    <li class="header" v-show="showSelectPage == 0 " style="margin-top:10px;padding-top:10px;">
						
                        <div class="main-title">&nbsp;&nbsp;&nbsp;部分服务企业<span style="font-size:12px;">(排名不分先后)</span></div>
                        <hr style="height:1px;border:none;border-top:1px solid #d0dee5;" />
                        <!-- <img style="margin:80px auto 0 auto;padding-bottom:40px;width:100%;" src="../assets/bg_fwqy.png"  />  -->
						<ul class="facilitator">
							<li class="facilitator_img" v-for="(item, index) in facilitatorImgList" :key="index">
								<img :src="item" alt="">
							</li>
						</ul>
                    </li>
                    <li v-show="showSelectPage == 1 " style="margin-top:10px;padding-top:10px;">
						<div class="main-title">&nbsp;&nbsp;&nbsp;一卡通厂商<span style="font-size:12px;">(排名不分先后)</span></div>
                        <hr style="height:1px;border:none;border-top:1px solid #d0dee5;" />
                        <!-- <img src="../assets/bg_yktcs.png" style="padding-left:25px;"  />  -->
						<ul class="facilitator"><!-- class="tsqy-boxs" -->
							<li class="facilitator_imgT" v-for="(item, index) in cardSolutionImgList" :key="index">
								<img :src="item" alt="">
							</li>
						</ul>
                    </li>
                </ul>
            </div>
        </el-main>
    </el-container>
    </el-container>
</div>
</template>
<style scoped>
.facilitator{
	display: inline-flex;
    flex-wrap: wrap;
    flex-direction: row;
}
.facilitator_img{
	width:167px;
	height:90px;
	margin:10px 34px;
	/* margin-bottom:16px !important;
	margin-right:67px !important; */
}
.facilitator_img img{
	width:167px;
	height:90px;
}
.facilitator_imgT{
	width:220px;
	height:90px;
	margin:10px 34px;
}
.facilitator_imgT img{
	width:220px;
	height:90px;
}
ul,li{
    list-style: none;margin:0 ;padding:0;
}
.second-td {
    font-family: "Microsoft Yahei";
}
.news-desc {
  padding-top: 15px;
}
@media screen and (max-width: 1280px) {
}
@media screen and (max-width: 1579px) and  (min-width: 1281px) {
}
@media screen and (min-width: 1580px) {
}
  .el-header {
    /*background-color: #B3C0D1;*/
    /*color: #333;*/
    line-height: 60px;
    margin:0 auto;
    
  }

  .news-main {
    /*text-align: center;*/
    margin-top: 60px;
    /* background-color: #F5F5F5; */
  }
  .news-main-container {
    margin:0 auto;
    width: 90%;
    padding-top: 10px;
  }
  .new-menu.is-active {
    border-left: solid 2px #409EFF;
		background: #EAF6FF;

  }
  .el-main {
    padding-top: 0px;
    background-color: #FFFFFF;
  }
  .el-menu {
    /* border-right: solid 0px!important; */
	
  }
  .el-menu {
    /* border-right: solid 0px!important; */
	    background: rgba(255,255,255,1);
		box-shadow: 0px 0px 14px 2px rgba(223,223,223,0.68);
		margin: 10px;
	}
	.el-menu-select-box{
		background: rgba(255,255,255,1);
		box-shadow: 0px 0px 14px 2px rgba(223,223,223,0.68);
	}
  .news-content {
    background-color: #FFFFFF;
    /* margin-left: 20px; */
  } 
  .el-menu-select-box .header {
		margin: 0 20px;
	}
  img {
    display : block ;
  }
  .main-title{
    border-left: solid 4px #409EFF;
    margin-top: 10px;
  }
.tsqy-boxs{
	  overflow: hidden;
    margin: 20px 0 0 20px;
}
.tsqy-boxs li{
	border: 1px solid #eeeeee;
    box-shadow: 0 0 5px #ddd;
    /* margin-bottom: 25px; */
    width: 31%;
    float: left;
	margin: 0 25px 25px 0;
}

.tsqy-boxs li>div>img{
	flex: 0 0 80px;
}
/* .tsqy-boxs li:last-child{
	margin-right:0;
} */
.tsqy-boxs li div{
	 padding: 0 10px;
    overflow: hidden;
    text-align: center;
}
.tsqy-boxs li img{
	/* float:left; */
	  /* width: 75px; */
    padding-right: 13px;
    display: inline-block;
    vertical-align: bottom;
	padding:4px 0;
	margin-right: 10px;
}
.tsqy-boxs li span{
	    font-size: 14px;
    display: inline-block;
    height: 68px;
    line-height: 68px;
	color:#333333;
}

.tsqy-boxs li>div{
	width: 70%;
    margin: 0 auto;
	display: flex;
	flex-direction: row;
  justify-content: space-between;
  justify-content: left;
}
.flexImg{
	width: 100px;
	flex: 0 0 100px;
}
</style>

<script>
  import axios from 'axios';
  export default {
    name:"media",
    data() {
      return {
        tableData: [],
        activeIndex:"0",
        total: 0,
        page: 1,
        pageSize: 30,
        type: 0,
        showSelectPage: 0,
		facilitatorImgList:[
			require('../assets/facilitator/图层1.png'),
			require('../assets/facilitator/图层2.png'),
			require('../assets/facilitator/图层3.png'),
			require('../assets/facilitator/图层4.png'),
			require('../assets/facilitator/图层5.png'),
			require('../assets/facilitator/图层6.png'),
			require('../assets/facilitator/图层7.png'),
			require('../assets/facilitator/图层8.png'),
			require('../assets/facilitator/图层9.png'),
			require('../assets/facilitator/图层10.png'),
			require('../assets/facilitator/图层11.png'),
			require('../assets/facilitator/图层12.png'),
			require('../assets/facilitator/图层13.png'),
			require('../assets/facilitator/图层14.png'),
			require('../assets/facilitator/图层15.png'),
			require('../assets/facilitator/图层16.png'),
			require('../assets/facilitator/图层17.png'),
			require('../assets/facilitator/图层18.png'),
			require('../assets/facilitator/图层19.png'),
			require('../assets/facilitator/图层20.png'),
			require('../assets/facilitator/图层21.png'),
			require('../assets/facilitator/图层22.png'),
			require('../assets/facilitator/图层23.png'),
			require('../assets/facilitator/图层24.png'),
			require('../assets/facilitator/图层25.png'),
			require('../assets/facilitator/图层26.png'),
			require('../assets/facilitator/图层27.png'),
			require('../assets/facilitator/图层28.png'),
			require('../assets/facilitator/图层29.png'),
			require('../assets/facilitator/图层30.png'),
			require('../assets/facilitator/图层31.png'),
			require('../assets/facilitator/图层32.png'),
			require('../assets/facilitator/图层33.png'),
			require('../assets/facilitator/图层34.png'),
			require('../assets/facilitator/图层35.png'),
			require('../assets/facilitator/图层36.png'),
			require('../assets/facilitator/图层37.png'),
			require('../assets/facilitator/图层38.png'),
			require('../assets/facilitator/图层39.png'),
			require('../assets/facilitator/图层40.png'),
			require('../assets/facilitator/图层41.png'),
			require('../assets/facilitator/图层42.png'),
			require('../assets/facilitator/图层43.png'),
			require('../assets/facilitator/图层44.png'),
			require('../assets/facilitator/图层45.png'),
			require('../assets/facilitator/图层46.png'),
			require('../assets/facilitator/图层47.png'),
			require('../assets/facilitator/图层48.png'),
			require('../assets/facilitator/图层49.png'),
			require('../assets/facilitator/图层50.png'),
			require('../assets/facilitator/图层51.png'),
			require('../assets/facilitator/图层52.png'),
			require('../assets/facilitator/图层53.png'),
			require('../assets/facilitator/图层54.png'),
			require('../assets/facilitator/图层55.png'),
			require('../assets/facilitator/图层56.png'),
			require('../assets/facilitator/图层57.png'),
			require('../assets/facilitator/图层58.png'),
			require('../assets/facilitator/图层59.png'),
			require('../assets/facilitator/图层60.png'),
			require('../assets/facilitator/图层61.png'),
			require('../assets/facilitator/图层62.png'),
			require('../assets/facilitator/图层63.png'),
			require('../assets/facilitator/图层64.png'),
			require('../assets/facilitator/图层65.png'),
			require('../assets/facilitator/图层66.png'),
			require('../assets/facilitator/图层67.png'),
			require('../assets/facilitator/图层68.png'),
			require('../assets/facilitator/图层69.png'),
			require('../assets/facilitator/图层70.png'),
		],
		cardSolutionImgList:[
			require('../assets/cardSolution//图层1.png'),
			require('../assets/cardSolution//图层2.png'),
			require('../assets/cardSolution//图层3.png'),
			require('../assets/cardSolution//图层4.png'),
			require('../assets/cardSolution//图层5.png'),
			require('../assets/cardSolution//图层6.png'),
			require('../assets/cardSolution//图层7.png'),
			require('../assets/cardSolution//图层8.png'),
			require('../assets/cardSolution//图层9.png'),
			require('../assets/cardSolution//图层10.png'),
			require('../assets/cardSolution//图层11.png'),
			require('../assets/cardSolution//图层12.png'),
			require('../assets/cardSolution//图层13.png'),
			require('../assets/cardSolution//图层14.png'),
			require('../assets/cardSolution//图层15.png'),
			require('../assets/cardSolution//图层16.png'),
			require('../assets/cardSolution//图层17.png'),
			require('../assets/cardSolution//图层18.png'),
			require('../assets/cardSolution//图层19.png'),
			require('../assets/cardSolution//图层20.png'),
		]
      }
    },
    methods: {
     handleSelect(val){
         console.log(val)
        var  path = "/website/cooperation_case/#"+val;
        this.$router.push(path);
        this.showSelectPage = val
         
     }
    },
    mounted(){
    }
  };
</script>


// WEBPACK FOOTER //
// src/components/cooperationCase.vue